import React from "react";

import { useTranslation } from "react-i18next";

import bill from '../../img/bill.png'
import card from '../../img/card.png'
import keyboard from '../../img/keyboard.png'

function Exposing () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[120px]">
            <div className="flex flex-col xl:flex-row justify-between items-center gap-[20px] xl:gap-0">
                <div className="flex flex-col">
                    <p className="text-black text-[20px] xl:text-[40px] manrope font-[500]">{t('home.36')}</p>
                    <p className="roboto font-[300] text-[14px] text-[#000000B2] xl:max-w-[500px] mt-[20px] xl:mt-[40px]">{t('home.37')}</p>
                    <p className="roboto font-[300] text-[14px] text-[#000000B2] xl:max-w-[500px] mt-[12px]">{t('home.38')}</p>
                </div>
                <img src={bill} alt="" />
                <img src={card} alt="" />
            </div>
            <div className="flex flex-col-reverse items-center gap-[20px] xl:flex-row mt-[60px]">
                <img src={keyboard} alt="" />
                <div>
                    <p className="manrope text-[#9D0032] text-[20px] xl:text-[25px] font-[500]">{t('home.39')}</p>
                    <div className="flex items-start xl:max-w-[500px] gap-[20px] mt-[20px] xl:mt-[40px]">
                        <svg className="flex-shrink-0 mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M9.75183 6.0936L0.611068 11.371L0.61107 0.816173L9.75183 6.0936Z" fill="#B30101"/>
                        </svg>
                        <p className="roboto text-[14px] leading-[1.4] font-[300] text-[#000000B2]">{t('home.40')}</p>
                    </div>
                    <div className="flex items-start xl:max-w-[500px] gap-[20px] mt-[12px]">
                        <svg className="flex-shrink-0 mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M9.75183 6.0936L0.611068 11.371L0.61107 0.816173L9.75183 6.0936Z" fill="#B30101"/>
                        </svg>
                        <p className="roboto text-[14px] leading-[1.4] font-[300] text-[#000000B2]">{t('home.41')}</p>
                    </div>
                    <div className="flex items-start xl:max-w-[500px] gap-[20px] mt-[12px]">
                        <svg className="flex-shrink-0 mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M9.75183 6.0936L0.611068 11.371L0.61107 0.816173L9.75183 6.0936Z" fill="#B30101"/>
                        </svg>
                        <p className="roboto text-[14px] leading-[1.4] font-[300] text-[#000000B2]">{t('home.42')}</p>
                    </div>
                    <div className="flex items-start xl:max-w-[500px] gap-[20px] mt-[12px]">
                        <svg className="flex-shrink-0 mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M9.75183 6.0936L0.611068 11.371L0.61107 0.816173L9.75183 6.0936Z" fill="#B30101"/>
                        </svg>
                        <p className="roboto text-[14px] leading-[1.4] font-[300] text-[#000000B2]">{t('home.43')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Exposing;